export default __webpack_public_path__ + "static/media/consult.85f3d2ad.svg";